import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useAssignmentDelete = () => {
  const createAssignmentDeleteRequest = useCallback((id) => {
    return new Request(`${MONOLITH_ORIGIN}/api/v3/assignment/${id}/`, {
      method: "DELETE",
    });
  }, []);
  return useRestMutation(createAssignmentDeleteRequest);
};

export default useAssignmentDelete;
